function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var FaucetAdminTemplate = require('./faucet-admin.template');
var FaucetAdmin = /*#__PURE__*/function () {
  function FaucetAdmin(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.admin-faucet';
    _classCallCheck(this, FaucetAdmin);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.state = null;
    this.error = '';
    this.loading = false;
    this.filter = 'recent';
    this.config = null;
    this.config_error = '';
    this.config_loading = false;
    this.config_saving = false;
    this.config_saved = false;
  }
  return _createClass(FaucetAdmin, [{
    key: "admin",
    value: function admin() {
      return this.app.modules.returnModule('Admin');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$admin;
      this.state = null;
      this.error = '';
      this.loading = false;
      this.filter = 'recent';
      this.config = null;
      this.config_error = '';
      this.config_loading = false;
      this.config_saving = false;
      this.config_saved = false;
      if (!((_this$admin = this.admin()) !== null && _this$admin !== void 0 && _this$admin.server_info)) {
        this.app.browser.replaceElementContentBySelector("<p class=\"admin-faucet-empty\">Waiting for the server to finish authenticating this administrator.</p>", this.container);
        return;
      }
      this.refresh();
      this.load();
      this.loadConfig();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.app.browser.replaceElementContentBySelector(FaucetAdminTemplate({
        state: this.state,
        error: this.error,
        loading: this.loading,
        filter: this.filter,
        config: this.config,
        config_error: this.config_error,
        config_loading: this.config_loading,
        config_saving: this.config_saving,
        config_saved: this.config_saved
      }), this.container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var btn = document.getElementById('admin-faucet-refresh');
      if (btn) {
        btn.onclick = function () {
          _this.load();
          _this.loadConfig();
        };
      }
      var copyKey = document.getElementById('admin-faucet-copy-key');
      if (copyKey) {
        copyKey.onclick = function () {
          var _this$state;
          var key = (_this$state = _this.state) === null || _this$state === void 0 ? void 0 : _this$state.privatekey;
          if (!key) {
            return;
          }
          navigator.clipboard.writeText(key).then(function () {
            if (typeof siteMessage === 'function') {
              siteMessage('copied to clipboard...', 2000);
            }
          });
        };
      }
      document.querySelectorAll('[data-faucet-filter]').forEach(function (el) {
        el.onclick = function () {
          _this.filter = el.getAttribute('data-faucet-filter') || 'recent';
          _this.load();
        };
      });
      document.querySelectorAll('.admin-faucet-row').forEach(function (row) {
        row.onclick = function () {
          var details = row.nextElementSibling;
          if (details && details.classList.contains('admin-faucet-details')) {
            var open = details.style.display !== 'none';
            details.style.display = open ? 'none' : 'table-row';
          }
        };
      });
      var form = document.getElementById('admin-faucet-config-form');
      if (form) {
        form.onsubmit = function (e) {
          var _document$getElementB, _document$getElementB2, _document$getElementB3;
          e.preventDefault();
          _this.saveConfig({
            github_secret: ((_document$getElementB = document.getElementById('admin-faucet-github-secret')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value) || '',
            twitter_secret: ((_document$getElementB2 = document.getElementById('admin-faucet-twitter-secret')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.value) || '',
            free_use: ((_document$getElementB3 = document.getElementById('admin-faucet-free-use')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.checked) === true
          });
        };
      }
    }
  }, {
    key: "sendAdminRequest",
    value: function () {
      var _sendAdminRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(request, data, callback) {
        var admin, tx;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              admin = this.admin();
              if (admin !== null && admin !== void 0 && admin.server_publickey) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(admin.server_publickey);
            case 2:
              tx = _context.v;
              tx.msg = _objectSpread({
                module: 'Admin',
                request: request
              }, data);
              _context.n = 3;
              return tx.sign();
            case 3:
              this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                return callback(res_tx.returnMessage());
              }, admin.server_publickey);
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function sendAdminRequest(_x, _x2, _x3) {
        return _sendAdminRequest.apply(this, arguments);
      }
      return sendAdminRequest;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loading = true;
              this.error = '';
              this.refresh();
              _context2.n = 1;
              return this.sendAdminRequest('list-faucet', {
                filter: this.filter
              }, function (res) {
                _this2.loading = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this2.error = res.err;
                  _this2.state = null;
                } else {
                  _this2.state = res.result || null;
                }
                _this2.refresh();
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "loadConfig",
    value: function () {
      var _loadConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this3 = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.config_loading = true;
              this.config_error = '';
              this.config_saved = false;
              this.refresh();
              _context3.n = 1;
              return this.sendAdminRequest('get-admin-config', {
                module_id: 'faucet'
              }, function (res) {
                _this3.config_loading = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this3.config_error = res.err;
                  _this3.config = null;
                } else {
                  _this3.config = res.result || null;
                }
                _this3.refresh();
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }()
  }, {
    key: "saveConfig",
    value: function () {
      var _saveConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
        var _this4 = this;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.config_saving = true;
              this.config_error = '';
              this.config_saved = false;
              this.refresh();
              _context4.n = 1;
              return this.sendAdminRequest('update-admin-config', {
                module_id: 'faucet',
                data: data
              }, function (res) {
                _this4.config_saving = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this4.config_error = res.err;
                } else {
                  _this4.config = res.result || _this4.config;
                  _this4.config_saved = true;
                  if (typeof siteMessage === 'function') {
                    siteMessage('Faucet configuration saved');
                  }
                }
                _this4.refresh();
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function saveConfig(_x4) {
        return _saveConfig.apply(this, arguments);
      }
      return saveConfig;
    }()
  }]);
}();
module.exports = FaucetAdmin;